import DeleteIcon from '@atlaskit/icon/core/delete';
import * as React from 'react';

export function SvgTrash() {
  return <DeleteIcon label="" testId="ads-refreshed-icon" />;
}
